<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <div style="margin-top: 2px">
            <el-button type="primary" size="mini" @click="batchAudit" :disabled="!btn.audit">{{ $t('getapi[1315]') }}</el-button>
            <el-button type="primary" size="mini" @click="batchReAudit" :disabled="!btn.reaudit">{{ $t('getapi[3070]') }}{{ $t('getapi[5161]') }}</el-button>
            <el-button type="primary" size="mini" @click="forcedShutdown" :disabled="!btn.forceshutdown">{{ $t('getapi[2345]') }}</el-button>
        </div>
        <el-tabs :tab-position="'top'" @tab-click="selectInfo">
            <el-tab-pane :label="$t('getapi[945]')" name="0">
                <vTable
                        id="xpane-0"
                        :height="tableHeight"
                        :data="dataSet"
                        :loading="loading"
                        queryData="VenderRFQView"
                        :filter_language="['Pur_STATUS']"
                        :filter_thousandth_purprice="['Material_Price']"
                        :filter_thousandth_puramount="['Process_Cost']"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleSelectionChange="handleSelectionChange"
                        @handleSelectionChangeAll="handleSelectionChangeAll"
                        @handleSelectionChangeEnd="handleSelectionChange"
                        @openFileList="openFileList"
                        ref="singleTable"
                ></vTable>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[6362]')" name="1">
                <wTable
                        id="xpane-1"
                        :data="personData"
                        :loading="loading"
                        queryData="VenderRFQView"
                        :filter_language="['Pur_STATUS','Material_Price','Process_Cost']"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleSelectionChange="handleSelectionChange"
                        ref="singleTable"
                ></wTable>
            </el-tab-pane>
        </el-tabs>

        <serce :isVisible="isVisible" queryData="VenderRFQView" ref="ser" @getser="serclick"></serce>
        <!-- 改变表格顺序 -->
        <ctable :isVisible="false" title="$t('getapi[12689]')" queryData="VenderRFQView" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag
                   :title="$t('getapi[6472]')"
                   :visible.sync="CloseDialogVisible"
                   width="30%"
        >
            <el-input
                    type="textarea"
                    :rows="5"
                    v-model="resontxt">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmReAudit">{{$t('getapi[1146]')}}</el-button>
            </span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visFile" width="40%" :close-on-click-modal="false">
            <el-table
                    header-row-class-name="headerclass"
                    stripe
                    :data="filedata"
                    border
                    height="500"
                    size="mini"
                    :highlight-current-row="true"
            >
                <el-table-column v-for="item in returnHeadArray"
                                 :key="item.ColumnsField"
                                 :prop="item.ColumnsField"
                                 :label="item.ColumnsName"
                >
                    <template scope="scope">
                    <span v-if="item.ColumnsField =='file_url'">
                        <span  style="text-decoration:underline;color:blue" @click="openFile(scope.row.file_url)">{{$t('getapi[6503]')}}</span>
                    </span>
                    <span v-else>
                        <span>{{scope.row[item.ColumnsField]}}</span>
                    </span>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visFile	=	false" size='mini'>{{ $t('getapi[2054]') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'purvenderrfq',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight1,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight1,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3-Common.reduceTableHeight1
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                personData: [],
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 100000, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                tableHeader: [],
                selectData: [],
                btn: {
                    audit: false,
                    reaudit: false,
                    forceshutdown: false,
                },
                resontxt:'',
                CloseDialogVisible:false,
                scrollTop:0,
                visFile:false,//图纸列表弹窗
                filedata:[],
                returnHeadArray:[],
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndexs)
                    }, 500);
                })
            },
            personData: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndexs)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        methods: {
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('VenderRFQView',0,PFileds=>{
                    that.tableHeader=PFileds;
                });
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12689]"),this.$t("getapi[17]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                that.btnauthority()
            },
            btnauthority() {
                let that = this;
                that.btn.audit = false
                that.btn.reaudit = false
                that.btn.forceshutdown = false
                console.log(that.selectData.length)
                if(that.selectData.length > 0){
                    that.btn.audit = that.selectData.every(val => {
                        return (val.Pur_STATUS == 1 || val.Pur_STATUS == 3)&& val.Pur_STATUS != ''
                    });
                    that.btn.reaudit = that.selectData.every(val => {
                        return (val.Pur_STATUS == 1 || val.Pur_STATUS == 3)&& val.Pur_STATUS != ''
                    });
                    that.btn.forceshutdown = that.selectData.every(val => {
                        return (val.Pur_STATUS == 0 || val.Pur_STATUS == 1 || val.Pur_STATUS == 3)&& val.Pur_STATUS != ''
                    });
                }
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'VenderRFQView');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            handleSelectionChange({checked, records }){
                let that = this;
                that.selectData=records;
                that.btnauthority()
            },
            handleSelectionChangeAll({ records }){
                let that = this;
                that.selectData = records;
                that.btnauthority()
            },
            /*handleSelectionChange({checked, records }) {
                let that = this;
                that.selectData = records;
                that.btnauthority()
            },
            //全选
            handleSelectionChangeAll({ records }){
                let that = this;
                that.selectData = records;
                that.btnauthority()
            },*/
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pur/RFQB/PurVenderRFQViewDataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.btnauthority()
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[12439]')
                };
                that.$http.urlpost('/Pur/RFQB/PurVenderRFQViewExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            batchAudit(){
                let that =this;
                let msgs = that.$t('getapi[8606]')//'确认审核通过吗?';
                this.$confirm(msgs, that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            "auditflag": 1,
                            "auditmsg": '',
                            "Lists": that.selectData
                        }
                        that.$http.urlpost('/Pur/RFQB/BatchPurVenderRFQAudit', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                            }
                        });


                    })
                    .catch(() => {
                        // this.$message({
                        //     type: 'info',
                        //     message: '已取消删除'
                        // });
                    });

            },
            batchReAudit(){
                let that = this
                that.CloseDialogVisible = true
                that.resontxt = ''
            },
            comfirmReAudit(){
                let that = this
                let parm = {
                    "auditflag": 0,
                    "auditmsg": that.resontxt,
                    "Lists": that.selectData
                }
                that.$http.urlpost('/Pur/RFQB/BatchPurVenderRFQAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.CloseDialogVisible = false
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            forcedShutdown(){
                let that =this;
                let msgs = that.$t('getapi[2365]')//'确认审核通过吗?';
                this.$confirm(msgs, that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            "auditflag": 3,
                            "auditmsg": '',
                            "Lists": that.selectData
                        }
                        that.$http.urlpost('/Pur/RFQB/BatchPurVenderRFQAudit', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                            }
                        });


                    })
                    .catch(() => {
                        // this.$message({
                        //     type: 'info',
                        //     message: '已取消删除'
                        // });
                    });
            },
            selectInfo(tab, event){
                let that = this
                that.SelectIndexs = tab.name
                if(that.SelectIndexs == 0){
                    that.getView()
                } else if(that.SelectIndexs == 1){
                    that.getAuditPerson()
                }
                that.$nextTick(function(){
                    that.$processdata.initForm(that.SelectIndexs)
                });
            },
            getAuditPerson(){
                let that = this
                that.$http.urlpost('/Pur/RFQB/PurVenderRFQViewByAudit', '' , function (res) {
                    if (res.Success == 1) {
                        that.personData = res.DataContent
                    }
                });
            },
            //打开图纸弹窗列表
            openFileList(data){
                let that = this
                let parm = {
                    ImgFile_Url: data.ImgFile_Url,
                    ImgFile_OIPUrl:data.ImgFile_OIPUrl,
                    LangType:that.$processdata.getLang(),
                }
                that.$http.urlpost('/Pur/RFQB/GetImgFileOIPUrlList', parm , function (res) {
                    if (res.Success == 1) {
                        that.visFile = true
                        that.filedata = res.DataContent.DataList
                        that.returnHeadArray = res.DataContent.ColumnsList
                    }
                });
            },
            //打开文件
            openFile(url){
                window.open(url)
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
